// ga-disable prefix means that the Google Analytics script is disabled
// and the cookies are not set until the user gives consent (GDPR)

export const environment = {
    production: false,
    gaTagId_env: '_ga_CM9H9FKS5D',
    gaTagId_generic: '_ga',
    gaDevContainer: 'ga-disable-G-CM9H9FKS5D',
    gaProdContainer: 'ga-disable-G-2FJZMX1LQ8',
    ga_domain: '.kempower.io',
};
